<template>
  <el-container height="auto">
    <el-main>
      <div v-if="(this.userinfo.openid || '')==''" style="text-align:center">
        
        <div style="padding:8px;">
          请先开启患者互动
        </div>
        <img :src="'/console/user/me?id=' + userinfo.userid" style="width:300px;"/>
        <div style="padding:8px;">
          请使用微信扫描二维码后刷新页面
          
        </div>
      </div>
      <div v-else style="text-align:center">
        <div style="padding:8px;">
          您已授权微信访问：<i class="fa fa-weixin" style="color:#04BE02"></i>{{this.userinfo.nickname}}
        </div>
        <el-divider></el-divider>
        <div style="padding:8px;">
          请用微信扫码加入交流
        </div>
        
        <img :src="'/console/user/qrcode?id=' + userinfo.userid" style="width:300px;"/>
        <div style="padding:8px;">
          {{this.userinfo.username}} 医生
          <br>
          该二维码（{{this.userinfo.weixin_expireddate}}前）有效
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
     
      return {
        userinfo:{},
      }
    },
    mounted(){
      this.getProfile();
    },
    methods: {
      getProfile(){
        this.$http.get('user/profile').then((res) => {
            this.userinfo = res.data.info;
        });
      },
    }
  }
</script>
<style scoped>

</style>